import type { Middleware } from '@reduxjs/toolkit';

/** redux-persist key for `key: 'root'` in persist config */
const PERSIST_ROOT_KEY = 'persist:root';

const USER_CLEAR_TYPE = 'user/clearUser';

export type RemovePersistRoot = () => void | Promise<unknown>;

/**
 * Clears the persisted store key after `user/clearUser` is fully processed.
 * `storage.removeItem` (and redux-persist internals) must not run during a reducer
 * to avoid Redux error #6: unsubscribe during synchronous reducer run.
 */
export const createClearUserPersistAfterMiddleware = (
  removePersistRoot: RemovePersistRoot
): Middleware => {
  return () => (next) => (action) => {
    const actionType = (action as { type: string })?.type;
    const result = next(action);
    if (actionType === USER_CLEAR_TYPE) {
      queueMicrotask(() => {
        void removePersistRoot();
      });
    }
    return result;
  };
};

export { PERSIST_ROOT_KEY, USER_CLEAR_TYPE };
